import './App.css';
import React from "react";
import Main from '../src/Components/Main'
import Navbar from './Components/Navbar';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';





// const theme = createTheme({
//   palette: {
//     primary: {
//       main: orange[50],
//     },
//     secondary: {
//       main: lightGreen[800],
//     },
//   },
// });

function App() {
  return (
    <div className='app-container'>

    {/* <ThemeProvider theme={darkTheme}> */}
      <CssBaseline />
      <Navbar />
      <Main />
    {/* </ThemeProvider> */}
    </div>
  );
}

export default App;
